import React, { useState, useEffect, useCallback, useContext } from "react";
import TopBarSearchBox from "./TopBarSearchBox";
import SearchModal from "../../common/lib/SearchModal/SearchModal";
import { ApplicationDataAPI } from "../../common/lib/API/ApplicationDataAPI";
import useAPIError from "../../common/lib/APIError";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Fab from "@material-ui/core/Fab";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import AccountCircle from "@material-ui/icons/AccountCircle";
import AppsIcon from "@material-ui/icons/Apps";
import HomeIcon from "@material-ui/icons/Home";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import TopBarIcons from '../../common/lib/TopBarComponents'
import moment from 'moment';
import SearchAppContext from "../../common/lib/ApplicationQueue/searchedAppContext";

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
	},
	menuButton: {
		color: "white",
	},
	title: {
		flexGrow: "1",
	},
	title2: {
		flexGrow: "1",
		marginRight: "15%",
	},
	menuItem: {
		"&:hover": {
			color: "#ffffff",
			background: "#2E3B55",
		},
	},
	fab: {
		height: "25px !important",
		fontSize: "0.75rem !important",
		textTransform: "capitalize !important",
		background: "#b6ab22 !important",
		cursor: "default",
		marginLeft: "0.5rem",
	},
}));

function TopBar(props) {
	const { searchedQueue } = useContext(SearchAppContext);
	const classes = useStyles();
	const { addError } = useAPIError();
	const [app, setApp] = useState({});
	const [microApps, setMicroApps] = useState([]);
	const [appMenuEl, setAppMenuEl] = useState(null);
	const [accMenuEl, setAccMenuEl] = useState(null);
	const [searchModalOpen, setSearchModalOpen] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [isClose, SetIsClose] = useState(false);
	const [searchString, setSearchString] = useState("");
	const [appResults, setAppResults] = useState([]);
	const [statusBarMsg, setStatusBarMsg] = useState("");

	window.handleContainerAppSelection = (app) => {
		setApp(app);
	};

	window.verifyApplicationStatus = () => {
		if (app) {
			return true
		}
		return false
	}

	// Setting the browser Tab tile.
	document.title = props.stage;

	useEffect(() => {
		setMicroApps([]);
	}, []);

	const handleQueueDrawerClick = (event) => {
		if (window.toggleQueueDrawer) {
			window.toggleQueueDrawer();
		} else {
			console.log("No Drawer Clicked Handler found");
		}
	};

	const handleSearchModalClose = () => {
		setSearchModalOpen(false);
		setSearchString("");
		SetIsClose(true);
	};

	const handleAppSearch = (searchString) => {
		SetIsClose(false);
		setSearchModalOpen(true);
		setSearchString(searchString);
	};


	const handleAppSearchByAPI = async (searchStringData, searchCriteria) => {
		try {
		  setIsLoading(true);
		  let searchObj = {};
		  let searchString = searchStringData;
		  switch (searchCriteria) {
			case "By Application Id":
			  searchObj = { id: searchString };
			  break;
			case "By Applicant":
			  searchObj = { applicant_name: searchString };
			  break;
			case "By Broker":
			  searchObj = { broker_account_name: searchString };
			  break;
			case "By Contract Number":
			  searchObj = { contract_number: searchString };
			  break;
			case "By Guarantor":
			  searchObj = { guarantor_name: searchString };
			  break;
			case "By Vendor":
			  searchObj = { vendor_name: searchString };
			  break;
			case "By VIN/Serial":
			  searchObj = { vin: searchString };
			  break;
			case "By SSN":
			  searchObj = { lessee_fein: searchString };
			  break;
			case "By Referral Party App Id":
			  searchObj = { referral_party_application_id: searchString };
			  break;
			default:
			  searchObj = {};
			  return;
		  }
	
		  let applications;
		  if (searchCriteria === "By SSN") {
			// searching apps where ssn is in application
			let appSsn = await ApplicationDataAPI.searchApplications(
			  searchObj,
			  "ALL"
			);
			// searching apps where ssn is in guarantors
			let guarSsn = await ApplicationDataAPI.searchApplications(
			  { action: "app_guarantor_fein", app_guarantor_fein: searchString },
			  "ALL"
			);
			applications = [...appSsn, ...guarSsn];
		  } else {
			applications = await ApplicationDataAPI.searchApplications(
			  searchObj,
			  "ALL"
			);
		  }
	
		  //limit the data to only 100 results
		  if (applications.length >= 100) {
			applications.length = 100;
		  }
	
		  if (applications) {
			setAppResults(applications);
			setSearchString("");
			setIsLoading(false);
		  }
		} catch (ex) {
		  console.log("Not found");
		  setAppResults([]);
		  setIsLoading(false);
		}
	  };

	const handleAppClick = (event) => {
		setAppMenuEl(event.currentTarget);
	};

	const handleHomeClick = () => {
		window.location = "/";
	};

	const handleAppClose = (event, route) => {
		setAppMenuEl(null);
		if (route) {
			window.location = route;
		}
	};

	const handleAccountClick = (event) => {
		setAccMenuEl(event.currentTarget);
	};

	const handleAccountClose = () => {
		setAccMenuEl(null);
	};

	const handleLogout = useCallback(() => {
		handleAccountClose()
		window.authProvider.logout()
	}, [])

	return (
		<div className={classes.root}>
			<AppBar position="static" style={{ background: "#2E3B55", color: "white" }}>
				<Toolbar>
					<IconButton
						edge="start"
						className={classes.menuButton}
						style={{ color: "#cf9d10" }}
						onClick={() => handleHomeClick()}
						aria-label="home">
						<HomeIcon />
					</IconButton>

					<TopBarSearchBox
						callback={handleAppSearch}
						handleAppSearchByAPI={handleAppSearchByAPI}
						isClose={isClose}
					/>

						<Typography
						variant="h6"
						className={app?.id === undefined ? classes.title2 : classes.title}>
						
						

						{/* Set queue of searched app if possible */}
						{app.id && searchedQueue.length > 0
                		? `${searchedQueue.toLocaleUpperCase()} - ${app.id} - ${
                    	app.record_type
                  		}`
						: app.id 
						? `${props.stage} - ${app.id} - ${app.record_type}`
						: props.stage}

						{app.id
							? statusBarMsg && (
								<>
									<br />
									<Fab
										variant="extended"
										size="small"
										color="primary"
										aria-label="add"
										className={classes.fab}>
										{statusBarMsg}
									</Fab>
								</>
							)
							: ""}
						{app.date_entered_in_current_queue && (
							<Typography variant="subtitle2">{`Entry on ${moment(app.date_entered_in_current_queue).format(
								"MM/DD/YYYY"
							)} at ${moment(app.date_entered_in_current_queue).format("hh:mm a")}`}
							</Typography>
						)}
					</Typography>
					<TopBarIcons app={app} isReadOnly={props.isReadOnly} />
					<IconButton
						className={classes.menuButton}
						color="inherit"
						aria-label="User info"
						onClick={handleAccountClick}>
						<AccountCircle />
					</IconButton>
					<Menu
						id="account-menu"
						anchorEl={accMenuEl}
						keepMounted
						open={Boolean(accMenuEl)}
						onClose={handleAccountClose}>
						<MenuItem onClick={handleAccountClose}>
							{window.authProvider.account?.name}
						</MenuItem>
						<MenuItem onClick={handleLogout}>Logout</MenuItem>
					</Menu>
				</Toolbar>
			</AppBar>
			<SearchModal
				open={searchModalOpen}
				onClose={handleSearchModalClose}
				searchString={searchString}
				appResults={appResults}
				setAppResults={setAppResults}
				setSearchString={setSearchString}
				handleAppSearchByAPI={handleAppSearchByAPI}
				isLoading={isLoading}
				setIsLoading={setIsLoading}
				app={app}
			/>
		</div>
	);
}

export default TopBar;
